module.exports = __webpack_public_path__ + "static/46-pewdiepie-jan2019-ff2c2375b385bb4bee337b7f96273b14.jpg";